import React, { useEffect, useMemo, useState } from 'react';
import UserService from '../services/user/UserService';

const Pegawai = ({ id }) => {
    let userService = useMemo(() => new UserService(), [])
    const [urUpt, setUrUpt] = useState('')

    useEffect(() => {
        const getUpt = async () => {
            try {
                const response = await userService.getPegawaiById(id)
                setUrUpt(response.data.nama)
            } catch (error) {
                setUrUpt('')
            }
        }
        getUpt()
    }, [userService, id])

    return (
        <>
            {urUpt}
        </>
    )
}

export default Pegawai